






























































import { Component, Vue, Prop } from "vue-property-decorator";
import { DeleteExams$ } from "@/request/jxgl";
@Component({})
export default class KsglResultList extends Vue {
  @Prop()
  private results;
  @Prop()
  private filters;
  /**
   * @description 查看
   */
  private check(row) {
    this.$router.push({
      path: "/main/szjx/szks-result",
      query: {
        id: row["exam_id"],
        user_id: row["user_id"],
      },
    });
  }
}
